"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSuggestions = exports.parseRecentSearches = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constant = require("./constant");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var getIcon = function getIcon(locationType) {
  // eslint-disable-next-line no-param-reassign
  locationType = locationType.toLowerCase();

  switch (locationType) {
    case _constant.LOCATION_TYPES.AIR_PORT:
      return _constant.ICONS.FLIGHT_ICON;

    case _constant.LOCATION_TYPES.REGION:
    case _constant.LOCATION_TYPES.CITY:
    case _constant.LOCATION_TYPES.LANDMARK:
    case _constant.LOCATION_TYPES.NEIGHBORHOOD:
      return _constant.ICONS.LOCATION_ICON;

    case _constant.LOCATION_TYPES.HOTEL:
      return _constant.ICONS.LOCATION_ICON;

    default:
      return '';
  }
};

var getSubDisplayName = function getSubDisplayName(suggestion) {
  return suggestion.full_name.replace("".concat(suggestion.name, ","), '').trim();
};

var parseItems = function parseItems(items) {
  return items.map(function (suggestion) {
    // TODO: need to localize iconDisplayName;
    return _objectSpread(_objectSpread({}, suggestion), {}, {
      mainDisplayName: suggestion.name,
      subDisplayName: getSubDisplayName(suggestion),
      iconDisplayName: suggestion.type,
      iconName: getIcon(suggestion.type)
    });
  }).filter(function (_ref) {
    var iconName = _ref.iconName;
    return iconName !== '';
  });
};

var parseSuggestions = function parseSuggestions(results) {
  if (results && results.suggestions && results.suggestions.length > 0) {
    var formattedResults = parseItems(results.suggestions);
    return formattedResults;
  }

  return [];
};

exports.parseSuggestions = parseSuggestions;

var parseRecentSearches = function parseRecentSearches(recentSearches) {
  if (recentSearches && recentSearches.length > 0) {
    return {
      destinations: parseItems(recentSearches.map(function (searchItem) {
        return searchItem.destination;
      })),
      date: recentSearches[0].date,
      rooms: recentSearches[0].rooms
    };
  }

  return {};
};

exports.parseRecentSearches = parseRecentSearches;